/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import type { AxiosRequestConfig, AxiosResponse } from 'axios'
import { axiosInstance } from '../client'
import type {
	AnalyticsWhatsAppOrganisationAnalyticsQueryParams,
	AnalyticsWhatsAppOrganisationAnalyticsResponse,
} from '../types/AnalyticsWhatsAppOrganisationAnalytics'

/**
 * GET /whatsapp-analytics
 * @see backend/nexus/modules/Analytics/Http/Controllers/AnalyticsController.php AnalyticsController::whatsAppOrganisationAnalytics
 */
export async function analyticsWhatsAppOrganisationAnalytics(
	params?: AnalyticsWhatsAppOrganisationAnalyticsQueryParams,
	config?: AxiosRequestConfig,
): Promise<AxiosResponse<AnalyticsWhatsAppOrganisationAnalyticsResponse>> {
	return axiosInstance.get('/whatsapp-analytics', { params, ...config })
}
